<app-simple-responsive-frame>
    <div class="confirm-location-container">
        <h2 class="title">Confirma la ubicación de tu {{ segmentLabel?.toLowerCase() }} en el mapa.</h2>

        <!-- CONTENEDOR DEL MAPA -->
        <div class="map-container">
            <input
                #searchInput
                type="text"
                class="search-input"
                placeholder="¿Qué estás buscando?"
            />
            <div #mapElement class="map"></div>
        </div>
        <!-- OPCIONES DE VISIBILIDAD -->
        <div class="location-visibility-container">
            <p class="title-medium">¿Cómo quieres que mostremos tu {{ segmentLabel?.toLowerCase() }}?</p>

            <div class="visibility-options">
                <label *ngFor="let option of targetTypes" class="radio-label">
                    <p-radioButton
                        name="displayOption"
                        [value]="option.optionName"
                        [(ngModel)]="selectedTargetType"
                        (ngModelChange)="onDisplayOptionChange(option)">
                    </p-radioButton>
                    <span>{{ option.optionName }}</span>
                </label>
            </div>
        </div>
    </div>

    <app-page-navigation-bar
        [value]="25"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="currentMode"
        [stepKey]="'maps'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
        (saveAndExit)="handleSaveAndExit()">
    </app-page-navigation-bar>


</app-simple-responsive-frame>
